/* eslint-disable camelcase */
import {
  createRequestContract,
  createResponseContract,
  createSpec,

  requestVerbs,
  responseTypes,
  specTypes,
} from '@bingads-webui-react/overreact';

import { composeSearchString } from '@bingads-webui-react/overreact-odata';

import { edm } from '../../../../../env/edm';
import { environmentLookupFn } from '../../../../../env/env-instance';
import { schema } from '../../../../../env/schema';

import {
  urlDecorator,
  headerDecorator,
  processorDecorator,
  keySelectorDecorator,
  sideEffects,

  networkPolicy,
} from './destroy-decorators';

function odataUrlFactory(params) {
  const { variables } = params;
  const { locator: { descriptor } } = variables;
  const {
    customer_id,
    account_id,
  } = descriptor;

  const edmEntity = edm
    .Customers.$withKey(customer_id)
    .Accounts.$withKey(account_id);

  const searchString = composeSearchString(variables, edmEntity, false);
  return `${edmEntity.path}${searchString}`;
}

function odataHeaderFactory(params) {
  const { headers } = params;
  return headers;
}

const requestContract = createRequestContract({
  schema,
  dataPath: 'customer:account',
  verb: requestVerbs.DELETE,
  fetchPolicy: networkPolicy,
  uriFactoryFn: urlDecorator(odataUrlFactory),
  headerFactoryFn: headerDecorator(odataHeaderFactory),
  keySelector: variables => variables.locator.descriptor.account_id,
  parentKeySelector: variables => variables.locator.descriptor.customer_id,
});

const responseContract = createResponseContract({
  requestContract,
  responseType: responseTypes.ENTITY,
  keySelector: keySelectorDecorator(r => r.Id),
  processorFn: processorDecorator(r => r),
});

export const destroySpec = createSpec(
  requestContract,
  responseContract,
  specTypes.DELETE,
  sideEffects.destroy,
  environmentLookupFn
);
